import { Component, Input, Output, EventEmitter } from '@angular/core';

export enum IdentitableButtonEnum {
  IdentibasePlusButton = 'IdentibasePlusButton',
  IdentialertButton = 'IdentialertButton',
  IdentifindButton = 'IdentifindButton',
}

@Component({
  selector: 'app-subscription-table-desktop',
  templateUrl: './subscription-table-desktop.component.html',
  styleUrls: ['./subscription-table-desktop.component.scss'],
})
export class SubscriptionTableDesktopComponent {
  @Input() identibasePlusButtonLabel: string;
  @Input() identialertButtonLabel: string;
  @Input() identifindButtonLabel: string;
  @Input() buyButtonVisible: boolean;
  @Input() buyButtonDisabled: boolean;
  @Output() identitableButtonClicked: EventEmitter<string> = new EventEmitter();

  @Input() basicPlusHighlighted: boolean;
  @Input() alertHighlighted: boolean;
  @Input() findHighlighted: boolean;

  public regularIconSource =
    '/assets/images/identibase/identi-table-icons/checkmark.svg';
  public highlightedIconSource =
    '/assets/images/identibase/identi-table-icons/orange-checkmark.svg';

  public IdentitableButtonEnum = IdentitableButtonEnum;

  public onIdentitableButtonClicked(buttonClicked: string) {
    this.identitableButtonClicked.emit(buttonClicked);
  }
}
